import { normalizeEvaluatedPriceForDisplay } from "../../../../../tools/ItineraryPricingEvaluationDisplay.tools";
import { type SegmentOfferDisplayData } from "../OfferPricing.types";

/** Label when the segment exposes a direct offer or booking URL. */
export const SEGMENT_OFFER_DIRECT_LINK_LABEL = "Voir l'offre";

/** Label when the segment maps to a known bike station. */
export const SEGMENT_BIKE_STATION_LINK_LABEL = "Voir la station";

/** Label when only the provider homepage or generic deep-link is available. */
export const SEGMENT_OFFER_PROVIDER_SITE_LINK_LABEL = "Voir sur le site du fournisseur";

/**
 * Normalizes a segment offer evaluated price for timeline display.
 *
 * @param price - Raw evaluated segment price.
 * @returns Positive finite amount, or `null` when nothing should be shown.
 */
export const normalizeSegmentOfferDisplayPrice = ( price: number | null ): number | null => {
    return normalizeEvaluatedPriceForDisplay( price );
};

/**
 * Resolves the segment side-panel link label from offer vs provider-site URLs.
 *
 * @param display - Segment offer display payload.
 * @returns Link label, or `null` when no URL is available.
 */
export const getSegmentOfferLinkLabel = ( display: Pick<SegmentOfferDisplayData, "offerBookingUrl" | "providerSiteUrl"> ): string | null => {
    if ( display.offerBookingUrl != null ) {
        return SEGMENT_OFFER_DIRECT_LINK_LABEL;
    }

    if ( display.providerSiteUrl != null ) {
        return SEGMENT_OFFER_PROVIDER_SITE_LINK_LABEL;
    }

    return null;
};
